import * as v1 from './m2m-core.v1';
export const m2mCore = {
  v1
};
